export type PlatformStepType = "delay" | "send_email";

export type StepDelay = {
  minutes?: number;
  hours?: number;
  days?: number;
};

export type TemplateRef = {
  templateSource: "wembii" | "provider";
  templateId: number;
  templateVersionId?: number;
};

export type DelayStep = {
  id: string;
  type: "delay";
  order: number;
  delay: StepDelay;
};

export type SendEmailStep = {
  id: string;
  type: "send_email";
  order: number;
  topic?: string;
  sendAtTime?: string;
  deliveryTiming?: "immediate" | "next_scheduled_time";
  defaultLocale?: string;
  templatesByLocale?: Record<string, TemplateRef>;
};

export type PlatformAutomationStep = DelayStep | SendEmailStep;

export type PlatformAutomationDraft = {
  trigger?: string;
  enrollmentPolicy?: string;
  defaultLocale?: string;
  defaultTimezone?: string;
  welcomeStepPolicy?: string;
  conditions?: {
    all?: Array<{ field: string; operator: string; value: unknown }>;
  };
  stopRules?: Array<Record<string, unknown>>;
  steps?: PlatformAutomationStep[];
};

export type TimelineItem = {
  stepId: string;
  type: PlatformStepType;
  dayOffset: number;
  offsetMinutes: number;
  offsetLabel: string;
  label: string;
  detail?: string;
};

export const PLATFORM_LOCALES = ["es", "en", "pt-BR"] as const;

export const PLATFORM_VARIABLES = [
  "user.firstName",
  "user.lastName",
  "user.email",
  "user.planName",
  "user.trialDaysLeft",
] as const;

export const TRIGGER_OPTIONS = [
  {
    value: "user_email_verified",
    label: "Usuario verifica su email",
  },
] as const;

export const TIMEZONE_OPTIONS = [
  { value: "America/Santiago", label: "Chile (Santiago)" },
  { value: "America/Sao_Paulo", label: "Brasil (São Paulo)" },
  { value: "America/Argentina/Buenos_Aires", label: "Argentina (Buenos Aires)" },
  { value: "America/Mexico_City", label: "México" },
  { value: "UTC", label: "UTC" },
] as const;
